import type { FunctionComponent } from 'react';

export const KeyCap: FunctionComponent<{ readonly children: string }> = ({ children }) => (
    <kbd className="inline-flex h-5 min-w-5 shrink-0 select-none items-center justify-center rounded-sm border border-b-[1.5px] border-border-muted/60 bg-surface-subtle/50 px-xxs font-sans text-body-xxs leading-none text-text-content-subtle">
        {children}
    </kbd>
);
